//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  PinterestGatewayBoard,
  PinterestGatewayUser,
} from '@bvengineering/pinterest-gateway-service-types';

export interface IPinterestUserState {
  boards: PinterestGatewayBoard[];
  user?: PinterestGatewayUser;

  errors: {
    fetchUserBoardsError?: string;
    fetchUserError?: string;
  };
  flags: {
    hasFetchedUserBoards: boolean;
    isFetchingUserBoards: boolean;
    isFetchingUser: boolean;
  };
}

// This is a arbitrary max page number to avoid infinite loop, not an actual limit
export const MAX_BOARD_PAGES = 500;
